import { Column, Row } from 'src/components-v2/Layout';
import styled from 'threads5/themes/styled';

const Heading3 = styled('h3')(({ theme }) => {
  return {
    fontFamily: theme.typography.plaidSans,
    fontSize: '3.0rem',
    fontWeight: 600,
    lineHeight: '120%',
    letterSpacing: '-1.5px',
    margin: 0,
    textAlign: 'center',
  };
});

const TableHeader = () => {
  return (
    <Row
      sx={{
        backgroundColor: {
          xs: 'transparent',
          sm: '#FFF',
        },
        borderRadius: '12px',
        boxShadow: {
          xs: 'none',
          sm: '0px 2px 8px 0px rgba(0, 0, 0, 0.08)',
        },
        padding: { sm: '20px 25px' },
        justifyContent: 'space-between',
        marginBottom: { xs: '26px', sm: '8px' },
      }}
      lgOffset={2}
      lg={20}
    >
      <Column xs={24} sm={6}>
        <Heading3
          sx={{
            textAlign: 'left',
          }}
        >
          Products
        </Heading3>
      </Column>
      <Column
        xs={0}
        sm={6}
        sx={{
          display: {
            xs: 'none',
            sm: 'block',
          },
        }}
      >
        <Heading3
          sx={{
            color: '#088181',
          }}
        >
          Pay as You Go
        </Heading3>
      </Column>
      <Column
        xs={0}
        sm={6}
        sx={{
          display: {
            xs: 'none',
            sm: 'block',
          },
        }}
      >
        <Heading3
          sx={{
            color: '#BB33D7',
          }}
        >
          Growth
        </Heading3>
      </Column>
      <Column
        xs={0}
        sm={6}
        sx={{
          display: {
            xs: 'none',
            sm: 'block',
          },
        }}
      >
        <Heading3
          sx={{
            color: '#0B7BBC',
          }}
        >
          Custom
        </Heading3>
      </Column>
    </Row>
  );
};

export default TableHeader;
